<template>
  <div id="gallery" class="gallery-wrap pb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style3 text-center mb-40">
            <span>Gallery Exhibition</span>
            <h2>Discover Your Eye Health From Our Medical Clinic</h2>
          </div>
        </div>
      </div>
      <div class="gallery-item-wrap style2">
        <div
          class="gallery-card style5"
          v-for="gallery in galleries"
          :key="gallery.id"
        >
          <img :src="gallery.image" alt="Image" />
          <div class="gallery-info">
            <div class="gallery-info-left">
              <h3>
                <router-link to="/gallery-details">
                  {{ gallery.title }}
                </router-link>
              </h3>
              <span>{{ gallery.tag }}</span>
            </div>
            <div class="gallery-info-right">
              <router-link class="gallery-icon" to="/gallery-details">
                <i class="ri-add-line"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "GalleryExhibition",
  data: () => ({
    galleries: [
      {
        id: 1,
        image: require("../../assets/images/gallery/gallery-20.jpg"),
        title: "Anesthesia",
        tag: "Special Service",
      },
      {
        id: 2,
        image: require("../../assets/images/gallery/gallery-21.jpg"),
        title: "Optometrist",
        tag: "Nefrology",
      },
      {
        id: 3,
        image: require("../../assets/images/gallery/gallery-22.jpg"),
        title: "Cornea Test",
        tag: "Checkup",
      },
      {
        id: 4,
        image: require("../../assets/images/gallery/gallery-23.jpg"),
        title: "Neurology",
        tag: "Cardiology",
      },
      {
        id: 5,
        image: require("../../assets/images/gallery/gallery-24.jpg"),
        title: "Parenting",
        tag: "Child Care",
      },
    ],
  }),
});
</script>